import { AiIcon } from '@newfront-insurance/nova-core';
import { motion } from 'framer-motion';

export function Greeting() {
  return (
    <div
      key="overview"
      className="mx-auto flex size-full max-w-3xl flex-col items-center justify-center gap-3 px-8 text-center md:mt-20"
    >
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{ delay: 0.5 }}
        className="flex items-center text-lg"
      >
        <AiIcon height={20} />
        How can I help you today?
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{ delay: 0.6 }}
        className="text-muted-foreground w-[80%] text-base"
      >
        I&apos;m Nova Assist, your AI assistant at Newfront. Ask me insurance questions, upload documents to analyze, or
        get help with calculations and communications.
      </motion.div>
    </div>
  );
}
